import { Dayjs } from 'dayjs'
import { transformNumberProperty } from '$utils'
import { StaffMemberRemunerationType } from '$constants'

export interface StaffMemberRemunerationHistory {
  id?: string
  type: StaffMemberRemunerationType | number
  rate: number
  validFrom?: Dayjs
}

// Function to apply transformations to StaffMemberRemunerationHistory object on save
export const transformStaffMemberRemunerationHistoryOnSave = (
  staffMemberRemunerationHistory: StaffMemberRemunerationHistory | undefined
): StaffMemberRemunerationHistory | undefined => {
  if (!staffMemberRemunerationHistory) return undefined

  return {
    ...staffMemberRemunerationHistory,
    rate: transformNumberProperty(`${staffMemberRemunerationHistory.rate}`),
  }
}
